if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.product-form__submit-text') ||
          this.submitButton.querySelector('span');

        this.successBadge = this.submitButton.querySelector('.product-form__success');
        this.spinner =
          this.submitButton.querySelector('.product-form__submit-loader') ||
          this.submitButton.querySelector('.loading__spinner');

        this.successTimeout = null;
        this.isSubmitting = false;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isSubmitting || this.submitButton.hasAttribute('disabled')) return;

        this.handleErrorMessage();
        this.error = false;
        this.isSubmitting = true;

        this.setLoadingState();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('disabled', 'disabled');
                this.submitButton.setAttribute('aria-disabled', 'true');
                if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              } else {
                this.submitButton.removeAttribute('disabled');
                this.submitButton.removeAttribute('aria-disabled');
              }

              this.error = true;
              this.clearVisualState();
              return;
            }

            if (!this.cart) {
              this.showSuccessState();
              setTimeout(() => {
                window.location = window.routes.cart_url;
              }, 250);
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            const openCartDrawer = () => {
              requestAnimationFrame(() => {
                this.cart.renderContents(response);
              });
            };

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(openCartDrawer, 500);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              setTimeout(openCartDrawer, 500);
            }

            this.showSuccessState();
          })
          .catch((e) => {
            console.error(e);
            this.error = true;
            this.clearVisualState();
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (this.error) {
              this.clearVisualState();
            }

            this.isSubmitting = false;
          });
      }

      setLoadingState() {
        clearTimeout(this.successTimeout);

        this.submitButton.classList.remove('is-success');
        this.submitButton.classList.add('is-loading');
        //this.submitButton.setAttribute('disabled', 'disabled');
       // this.submitButton.setAttribute('aria-disabled', 'true');

        if (this.spinner) this.spinner.classList.remove('hidden');
        if (this.successBadge) this.successBadge.classList.add('hidden');
      }

      showSuccessState() {
        clearTimeout(this.successTimeout);

        this.submitButton.classList.remove('is-loading');
        this.submitButton.classList.add('is-success');

        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.successBadge) this.successBadge.classList.remove('hidden');

        this.successTimeout = setTimeout(() => {
          this.submitButton.classList.remove('is-success');
          if (this.successBadge) this.successBadge.classList.add('hidden');

          const isSelectSize = this.submitButton.textContent.toLowerCase().includes('select a size');
          const isSoldOut = this.submitButton.textContent.toLowerCase().includes('sold out');
          if (!this.error && !isSoldOut && !isSelectSize && this.variantIdInput?.value) {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
          }
        }, 1600);
      }

      clearVisualState() {
        clearTimeout(this.successTimeout);

        this.submitButton.classList.remove('is-loading', 'is-success');

        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.successBadge) this.successBadge.classList.add('hidden');

        const isSelectSize = this.submitButton.textContent.toLowerCase().includes('select a size');
        const isSoldOut = this.submitButton.textContent.toLowerCase().includes('sold out');
        if (!this.error && !isSoldOut && !isSelectSize && this.variantIdInput?.value) {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        const nextText = text || (disable ? 'Sold out' : 'Add to basket');

        this.submitButton.toggleAttribute('disabled', disable);
        this.submitButton.toggleAttribute('aria-disabled', disable);

        this.submitButton.classList.remove('is-loading', 'is-success', 'loading');

        if (this.submitButtonText) {
          this.submitButtonText.classList.remove('hidden');
          if (this.submitButtonText.textContent !== nextText) {
            this.submitButtonText.textContent = nextText;
          }
        }

        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.successBadge) this.successBadge.classList.add('hidden');

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) {
          soldOutMessage.classList.toggle('hidden', !disable || nextText.toLowerCase().includes('select a size'));
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}